/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jade_Fast_Duck_MarchInputs */

const en_jade_fast_duck_march = /** @type {(inputs: Jade_Fast_Duck_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Only Classification`)
};

const de_jade_fast_duck_march = /** @type {(inputs: Jade_Fast_Duck_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur-KI-Klassifizierung`)
};

/**
* | output |
* | --- |
* | "AI-Only Classification" |
*
* @param {Jade_Fast_Duck_MarchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_fast_duck_march = /** @type {((inputs?: Jade_Fast_Duck_MarchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Fast_Duck_MarchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_fast_duck_march(inputs)
	return de_jade_fast_duck_march(inputs)
});